// tracking type
export const COURSE = 'course';
export const RC = 'regular_class';
// event
export const PLAY = 'play';
export const PAUSE = 'pause';
export const STOP = 'stop';
export const ENDED = 'ended';
export const PROGRESS_DRAG_START = 'progress_drag_start';
export const PROGRESS_DRAG_END = 'progress_drag_end';
export const FAST_FORWARD_START = 'fast_forward_start';
export const FAST_FORWARD_END = 'fast_forward_end';
export const REWIND_START = 'rewind_start';
export const REWIND_END = 'rewind_end';
